/* tslint:disable */
/* eslint-disable */
/**
 * Statistics API
 * API for retrieving dashboard statistics (goals, charts, market data)
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  GetDashboardStatisticsCommand,
  GetDashboardStatisticsResponse,
  GetMarketStatisticsCommand,
  GetMarketStatisticsResponse,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    GetDashboardStatisticsCommandFromJSON,
    GetDashboardStatisticsCommandToJSON,
    GetDashboardStatisticsResponseFromJSON,
    GetDashboardStatisticsResponseToJSON,
    GetMarketStatisticsCommandFromJSON,
    GetMarketStatisticsCommandToJSON,
    GetMarketStatisticsResponseFromJSON,
    GetMarketStatisticsResponseToJSON,
} from '../models/index';

export interface GetBoardStatsRequest {
    getDashboardStatisticsCommand: GetDashboardStatisticsCommand;
}

export interface GetCommercialFlowStatisticsRequest {
    getDashboardStatisticsCommand: GetDashboardStatisticsCommand;
}

export interface GetMarketStatisticsRequest {
    getMarketStatisticsCommand: GetMarketStatisticsCommand;
}

export interface GetObjectifsRequest {
    getDashboardStatisticsCommand: GetDashboardStatisticsCommand;
}

export interface GetRevenueStatisticsRequest {
    getDashboardStatisticsCommand: GetDashboardStatisticsCommand;
}

export interface GetStockStatisticsRequest {
    getDashboardStatisticsCommand: GetDashboardStatisticsCommand;
}

/**
 * 
 */
export class StatisticsApi extends runtime.BaseAPI {

    /**
     * Retrieves board statistics for the home dashboard.
     * Get board statistics
     */
    async getBoardStatsRaw(requestParameters: GetBoardStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDashboardStatisticsResponse>> {
        if (requestParameters['getDashboardStatisticsCommand'] == null) {
            throw new runtime.RequiredError(
                'getDashboardStatisticsCommand',
                'Required parameter "getDashboardStatisticsCommand" was null or undefined when calling getBoardStats().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/stats/home/board`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetDashboardStatisticsCommandToJSON(requestParameters['getDashboardStatisticsCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDashboardStatisticsResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves board statistics for the home dashboard.
     * Get board statistics
     */
    async getBoardStats(requestParameters: GetBoardStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDashboardStatisticsResponse> {
        const response = await this.getBoardStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves commercial flow statistics including new business count, quotes count, transformation rate, and simulations count. Data is grouped by year and can be filtered by product.
     * Get commercial flow statistics
     */
    async getCommercialFlowStatisticsRaw(requestParameters: GetCommercialFlowStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDashboardStatisticsResponse>> {
        if (requestParameters['getDashboardStatisticsCommand'] == null) {
            throw new runtime.RequiredError(
                'getDashboardStatisticsCommand',
                'Required parameter "getDashboardStatisticsCommand" was null or undefined when calling getCommercialFlowStatistics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/stats/dashboard/commercial-flow`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetDashboardStatisticsCommandToJSON(requestParameters['getDashboardStatisticsCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDashboardStatisticsResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves commercial flow statistics including new business count, quotes count, transformation rate, and simulations count. Data is grouped by year and can be filtered by product.
     * Get commercial flow statistics
     */
    async getCommercialFlowStatistics(requestParameters: GetCommercialFlowStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDashboardStatisticsResponse> {
        const response = await this.getCommercialFlowStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves market statistics as a paginated table showing subscriber details including name, type, customer since date, contract and simulation counts, total premium, products list, and status.
     * Get market statistics
     */
    async getMarketStatisticsRaw(requestParameters: GetMarketStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetMarketStatisticsResponse>> {
        if (requestParameters['getMarketStatisticsCommand'] == null) {
            throw new runtime.RequiredError(
                'getMarketStatisticsCommand',
                'Required parameter "getMarketStatisticsCommand" was null or undefined when calling getMarketStatistics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/stats/dashboard/market`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetMarketStatisticsCommandToJSON(requestParameters['getMarketStatisticsCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetMarketStatisticsResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves market statistics as a paginated table showing subscriber details including name, type, customer since date, contract and simulation counts, total premium, products list, and status.
     * Get market statistics
     */
    async getMarketStatistics(requestParameters: GetMarketStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetMarketStatisticsResponse> {
        const response = await this.getMarketStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves objectifs (goals/KPIs) for the statistics dashboard page.
     * Get objectifs (key indicators)
     */
    async getObjectifsRaw(requestParameters: GetObjectifsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDashboardStatisticsResponse>> {
        if (requestParameters['getDashboardStatisticsCommand'] == null) {
            throw new runtime.RequiredError(
                'getDashboardStatisticsCommand',
                'Required parameter "getDashboardStatisticsCommand" was null or undefined when calling getObjectifs().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/stats/dashboard/objectifs`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetDashboardStatisticsCommandToJSON(requestParameters['getDashboardStatisticsCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDashboardStatisticsResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves objectifs (goals/KPIs) for the statistics dashboard page.
     * Get objectifs (key indicators)
     */
    async getObjectifs(requestParameters: GetObjectifsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDashboardStatisticsResponse> {
        const response = await this.getObjectifsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves revenue-related statistics including contract premiums, commissions, and fees. Data is grouped by year and can be filtered by product.
     * Get revenue statistics
     */
    async getRevenueStatisticsRaw(requestParameters: GetRevenueStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDashboardStatisticsResponse>> {
        if (requestParameters['getDashboardStatisticsCommand'] == null) {
            throw new runtime.RequiredError(
                'getDashboardStatisticsCommand',
                'Required parameter "getDashboardStatisticsCommand" was null or undefined when calling getRevenueStatistics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/stats/dashboard/revenue`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetDashboardStatisticsCommandToJSON(requestParameters['getDashboardStatisticsCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDashboardStatisticsResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves revenue-related statistics including contract premiums, commissions, and fees. Data is grouped by year and can be filtered by product.
     * Get revenue statistics
     */
    async getRevenueStatistics(requestParameters: GetRevenueStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDashboardStatisticsResponse> {
        const response = await this.getRevenueStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves stock-related statistics including contract count, cancellation count, average premium per contract, and cancellation reasons. Data is grouped by year and can be filtered by product.
     * Get stock statistics
     */
    async getStockStatisticsRaw(requestParameters: GetStockStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDashboardStatisticsResponse>> {
        if (requestParameters['getDashboardStatisticsCommand'] == null) {
            throw new runtime.RequiredError(
                'getDashboardStatisticsCommand',
                'Required parameter "getDashboardStatisticsCommand" was null or undefined when calling getStockStatistics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/backoffice/stats/dashboard/stock`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetDashboardStatisticsCommandToJSON(requestParameters['getDashboardStatisticsCommand']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDashboardStatisticsResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves stock-related statistics including contract count, cancellation count, average premium per contract, and cancellation reasons. Data is grouped by year and can be filtered by product.
     * Get stock statistics
     */
    async getStockStatistics(requestParameters: GetStockStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDashboardStatisticsResponse> {
        const response = await this.getStockStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
